import type {Mapper} from 'framework';
import type {LineIngredientCandidate} from '../../domain/line-ingredient-candidate';
import {LINE_INGREDIENT_SOURCES} from '../../domain/line-ingredient-candidate';
import type {LineCandidatesDto} from '../dto/saved-meal.dto';

type CandidatesSuccess = Extract<LineCandidatesDto, {data: readonly unknown[]}>;
type CandidateDto = CandidatesSuccess['data'][number];

const selectSource = (value: string) =>
  LINE_INGREDIENT_SOURCES.find(source => source === value) ?? null;

export class LineCandidateDtoToCandidateMapper implements Mapper<
  CandidateDto,
  LineIngredientCandidate | null
> {
  transform(dto: CandidateDto): LineIngredientCandidate | null {
    const source = selectSource(dto.source);
    if (source === null) {
      return null;
    }
    return {
      source,
      name: dto.name,
      brand: dto.brand,
      barcode: dto.barcode,
      kcalPer100g: dto.kcalPer100g,
      proteinPer100g: dto.proteinPer100g,
      carbsPer100g: dto.carbsPer100g,
      fatPer100g: dto.fatPer100g,
      serving: dto.serving === null ? null : {unit: dto.serving.unit, grams: dto.serving.grams},
      productId: dto.productId,
    };
  }
}
